import { Button } from '@/components/Button';
import { SubmitHandler, useForm } from 'react-hook-form';
import { FormInput } from '@/components/FormInput';
import { useNavigate } from 'react-router';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowBack } from '@mui/icons-material';
import { useForgotMutation } from '@/models/auth';

type FormValues = {
  email: string;
};

export const ResetPasswordForm = () => {
  const [forgot, { error, isError, isSuccess }] = useForgotMutation();
  const [halt, setHalt] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onSubmit',
  });

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    const credentials = {
      ...data,
      callback: `${window.location.origin}/reset-password`,
    };
    try {
      await forgot(credentials);
    } catch (err: any) {
      console.log({ err });
    }
  };

  useMemo(() => {
    if (isError) {
      setHalt(true);
    }
    if (isError === false) {
      setHalt(false);
    }

    if (isSuccess) {
      navigate('/reset-link-sent');
    }
  }, [isError, isSuccess, navigate]);

  const backToLogin = () => navigate('/login');

  return (
    <div className="flex flex-col items-center justify-center w-full sm:w-80">
      <span className="mb-6 text-xl">{t('auth.reset_password.title')}</span>

      <span className="text-sm mb-6 text-slate-700">
        {t('auth.reset_password.description')}
      </span>

      {halt && (
        <span className="text-sm mb-6 text-red-500">
          {(error as any)?.data?.message}
        </span>
      )}

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full flex justify-center flex-col items-center"
      >
        <FormInput
          name="email"
          label="Email"
          control={control}
          rules={{
            required: t('validation.empty'),
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: t('auth.register.validation.email_wrong_format'),
            },
          }}
          error={errors.email}
          variant="outlined"
          fullWidth
          sx={{
            mb: '1rem',
          }}
        />

        <Button color="secondary" variant="contained" fullWidth type="submit">
          {t('auth.reset_password.submit')}
        </Button>
        <Button
          variant="text"
          size="large"
          fullWidth
          type="submit"
          style={{ marginTop: '15px' }}
          onClick={backToLogin}
          startIcon={<ArrowBack />}
        >
          {t('auth.reset_password.go_back')}
        </Button>
      </form>
    </div>
  );
};
